export var version = '3.8.1';
//# sourceMappingURL=version.js.map